
<div class="row">
  <div class="col-sm-12">
    <input type="hidden" >
    <mat-radio-group class="mt-card-ad-rpt" >
      <div class="row mt-crt-spc">
        <div class="col-sm-4" *ngFor="let address of addressList">
          <mat-card class="mat-card-cmn dlv-ads dlv-hr-bd">
            <mat-card-header>
              <mat-card-title>
                <mat-radio-group name="useraddress" >
                  <mat-radio-button [value]="address.AddressId" [checked]="selectedAddressId == address.AddressId"
                                    (click)="fn_SelectAddress(address.AddressId)">{{address.AddressType}}</mat-radio-button>
                </mat-radio-group>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="ads-info">
                <h4>{{address.Name}}</h4>
                <p>{{address.AddressLine}}, <br />
                  {{address.Country}}, {{address.State}}, <br />
                  {{address.ZipCode}}
                </p>
              </div>
              <div class="dlvr-dt-ara" *ngIf="selectedAddressId === address.AddressId">
                Deliver Here
              </div>
            </mat-card-content>
            <div class="mat-cart-ovl">
              <div class="mat-actn-d">
                <a class="edt-ui" (click)="fn_OpenEditAddressDialog(address.AddressId)"><i class="material-icons">
                  edit
                </i> </a>
                <a class="dlt-ui" (click)="fn_deleteAddress(address.AddressId)"><i class="material-icons">
                  delete_outline</i> </a>
              </div>
            </div>
          </mat-card>
        </div>
        <!-- ADD NEW ADDRESS -->
        <div class="col-sm-4">
          <div class="add-new-adrs">
            <div class="display-table">
              <div class="display-cell" (click)="fn_OpenAddAdressDialog()">
                <app-address-icon></app-address-icon>
                <p>Add New Address</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-radio-group>
  </div>
</div>
